var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-box"},[_c('span',{staticClass:"loader",style:({width: _vm.loaderSize, minWidth: _vm.loaderSize, height:_vm.loaderSize, minHeight:_vm.loaderSize})})])}
var staticRenderFns = []

export { render, staticRenderFns }